import _classCallCheck from "/Users/pete/Programs/go/AI/mind-nourish-tech-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { getCoordsDataType } from './shader_compiler';
export var CumOpType;
(function (CumOpType) {
  CumOpType["Prod"] = "*";
  CumOpType["Sum"] = "+";
})(CumOpType || (CumOpType = {}));
export var CumProgram = function CumProgram(op, outputShape, exclusive, reverse) {
  _classCallCheck(this, CumProgram);
  this.op = op;
  this.outputShape = outputShape;
  this.variableNames = ['x'];
  this.customUniforms = [{
    name: 'index',
    type: 'float'
  }];
  var rank = this.outputShape.length;
  var initVal = this.op === CumOpType.Prod ? '1.0' : '0.0';
  var val = exclusive ? initVal : "getX(".concat(getCoords(rank, 'coords', this.op), ")");
  var length = this.outputShape[this.outputShape.length - 1];
  var condition = '';
  var idxString = '';
  // When exclusive is set, the cum op becomes roll op that copies the
  // value from the previous index based on the direction specified by the
  // reverse flag.
  if (exclusive) {
    condition = reverse ? "end != ".concat(length - 1) : 'end != 0';
    idxString = reverse ? 'end + 1' : 'end - 1';
  } else {
    condition = reverse ? "end + pow2 < ".concat(length) : 'end >= pow2';
    idxString = reverse ? 'end + pow2' : 'end - pow2';
  }
  this.userCode = "\n      void main() {\n        ".concat(getCoordsDataType(rank), " coords = getOutputCoords();\n        int end = ").concat(getFinalCoord(rank, 'coords', this.op), ";\n        float val = ").concat(val, ";\n        int pow2 = int(pow(2.0, index));\n        if (").concat(condition, ") {\n          int idx = ").concat(idxString, ";\n          ").concat(getFinalCoord(rank, 'coords', this.op), " = idx;\n          val ").concat(this.op, "= getX(").concat(getCoords(rank, 'coords', this.op), ");\n        }\n        setOutput(val);\n      }\n    ");
};
function getCoords(rank, name, op) {
  if (rank === 1) {
    return "".concat(name);
  } else if (rank === 2) {
    return "".concat(name, ".x, ").concat(name, ".y");
  } else if (rank === 3) {
    return "".concat(name, ".x, ").concat(name, ".y, ").concat(name, ".z");
  } else if (rank === 4) {
    return "".concat(name, ".x, ").concat(name, ".y, ").concat(name, ".z, ").concat(name, ".w");
  } else {
    throw new Error("Cumulative ".concat(op, " for rank ").concat(rank, " is not yet supported"));
  }
}
function getFinalCoord(rank, name, op) {
  if (rank === 1) {
    return "".concat(name);
  } else if (rank === 2) {
    return "".concat(name, ".y");
  } else if (rank === 3) {
    return "".concat(name, ".z");
  } else if (rank === 4) {
    return "".concat(name, ".w");
  } else {
    throw new Error("Cumulative ".concat(op, " for rank ").concat(rank, " is not yet supported"));
  }
}